import type { DiagnosisResponse } from "../types";
import { apiFetch } from "./client";

export type DiagnosisPageType = "commerce" | "software";

/** 利用者が貼り付けた本文だけを、固定版のruleで診断する。 */
export function diagnoseDisplayText(
  text: string,
  pageType: DiagnosisPageType,
): Promise<DiagnosisResponse> {
  return apiFetch<DiagnosisResponse>("/api/diagnosis", {
    method: "POST",
    body: { text, page_type: pageType },
  });
}
